import { all } from 'redux-saga/effects';
import authSaga from './authSaga';
import logoSaga from './logoSaga';
import profileSaga from './profileSaga';
import dashboardSaga from './dashboardSaga/dashboardSaga';
import oemSaga from './oemSaga';
import settingSaga from './settingSaga';
import singleScanSaga from './scanSaga';
import countrySaga from './countrySaga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    logoSaga(),
    profileSaga(),
    dashboardSaga(),
    oemSaga(),
    settingSaga(),
    singleScanSaga(),
    countrySaga(),
  ]);
}